import { IonButton, IonCol, IonInput, IonRow, IonSpinner } from "@ionic/react";
import React, { FC, useEffect } from "react";
import { API_URL } from "../../../../actions/settings";
import NotificationPopUp from "../../../extras/NotificationPopUp";
import AnnualEnergyTargetDataTable from "./AnnualEnergyTargetDataTable";
import AnnualEnergyTargetSuggestions from "./AnnualEnergyTargetSuggestions";

async function getData(token: string, id: any, data: any) {
  return fetch(`${API_URL}/benchmark/run/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        console.log("error");
        console.log(res.json().then((data) => console.log(data)));
      }
    })
    .catch((error) => {
      NotificationPopUp("Error", error.message, "Error Getting Projections");
    });
}
async function getBaselineRates(token: string, id: any) {
  return fetch(`${API_URL}/benchmark/rates/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      console.log("error");
      console.log(res.json().then((data) => console.log(data)));
    }
  });
}

interface IProps {
  building?: string | null;
  data: any;
  setToolData: any;
  setReload: any;
}

const defaultTargets = {
  target_kwh_per_sqft: 0.0,
  target_therms_per_sqft: 0.0,
};

const AnnualEnergyTargetTool: FC<IProps> = (props) => {
  const [targets, setTargets] = React.useState<{ [key: string]: number }>(
    defaultTargets
  );
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const handleBaselineRates = async () => {
      const token = `Token ${(localStorage.getItem("token") || "").slice(
        1,
        -1
      )}`;
      const res = await getBaselineRates(token, props.building);
      if (res.status !== "error") {
        setTargets({
          target_kwh_per_sqft: res.data.kwh_per_sqft,
          target_therms_per_sqft: res.data.therms_per_sqft,
        });
      }
    };

    handleBaselineRates();
  }, [props.building]);

  const handleInputChange = (name: string, value: any) => {
    setTargets((prevTargets) => ({
      ...prevTargets,
      [name]: value ? parseFloat(value) : 0,
    }));
  };

  const handleRunBenchmark = async () => {
    setLoading(true);
    const token = `Token ${(localStorage.getItem("token") || "").slice(1, -1)}`;
    const res = await getData(token, props.building, targets);
    if (res) {
      props.setToolData(res.data);
    }
    props.setReload(true);
    setLoading(false);
  };

  return (
    <div>
      <IonRow style={{ borderBottom: "grey 2px solid"}}>
        <h3>Savings Projections</h3>
      </IonRow>
      <AnnualEnergyTargetSuggestions id={props.building} />
      <IonRow>
        <IonInput
          className="target-input"
          label="Target kWh/sf:"
          type="number"
          shape="round"
          inputmode="decimal"
          step="0.01"          
          onIonInput={(e) =>
            handleInputChange("target_kwh_per_sqft", e.detail.value!)
          }
          value={targets["target_kwh_per_sqft"]}
        ></IonInput>
        <IonInput
          className="target-input"
          label="Target therm/sf:"
          type="number"
          shape="round"
          step="0.01"
          inputmode="decimal"
          onIonInput={(e) =>
            handleInputChange("target_therms_per_sqft", e.detail.value!)
          }
          value={targets["target_therms_per_sqft"]}
        ></IonInput>
        <IonButton color="medium" onClick={() => handleRunBenchmark()}>
          {loading ? <IonSpinner /> : "projections"}
        </IonButton>
      </IonRow>
      
      {props.data ? (
        <IonRow>
          <IonRow className="eui-row" style={{ width: "100%" }}>
            <IonCol>
              <h4>Baseline EUI: {props.data.baseline_eui} </h4>
            </IonCol>
            <IonCol>
              <h4>Median EUI: {props.data.median_eui} </h4>
            </IonCol>
            <IonCol>
              <h4>Target EUI: {props.data.target_eui} </h4>
            </IonCol>
          </IonRow>
          <IonRow className="sqft-row" style={{ width: "100%" }}>
            <IonCol>
              <div>
                <h4 className="center-all">
                  Gross Floor Area: {props.data.sqft.toLocaleString("en")} ft
                  <sup>2</sup>
                </h4>
              </div>
            </IonCol>
          </IonRow>
          <IonCol style={{ marginTop: "0px", paddingTop: "0px" }}>
            <h3>kWh Data</h3>
            <AnnualEnergyTargetDataTable
              type={"kwh"}
              data={props.data.kwh_data}
            />
          </IonCol>
          <IonCol>
            <h3>Therms Data</h3>
            <AnnualEnergyTargetDataTable
              type={"therms"}
              data={props.data.therms_data}
            />
          </IonCol>
        </IonRow>
      ) : (
        <IonRow>
          <p>
            Enter Data to get savings projections or select a previous
            calculation.
          </p>
        </IonRow>
      )}
    </div>
  );
};

export default AnnualEnergyTargetTool;
